import { ApiServiceService } from './../../services/api-service.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {
  // constructor
  constructor(private fb: FormBuilder, private ApiService: ApiServiceService, private router: Router, private notifier:NotifierService) { }
  // local variables
  isAlert: string;
  hide=true;
  // create from builder group
  public login = this.fb.group({
    userName: ['', Validators.required],
    password: ['', Validators.required]
  });
  ngOnInit(): any {
    if (localStorage.getItem('LoginData')) {
      this.router.navigateByUrl('companies');
    }
  }
  // for login
  onLogin(): any {
    const form = document.getElementById('form');
    console.log('form===',this.login.value)
    if (this.login.valid) {
      form.classList.remove('was-validated');
      this.ApiService.postApi('easeUrBizUserLogin', this.login.value).subscribe((res: any) => {
        console.log(res);
        if (res.status == 'Success') {
          localStorage.setItem('LoginData', JSON.stringify(res.userData));
          this.notifier.notify('success', res.message);
          this.isAlert = null;
          setTimeout(() => {
            this.router.navigateByUrl('/companies');
          }, 1000);
        } else {
          this.notifier.notify('error', res.message);
          this.isAlert = res.message;
        }
      });
    } else {
      form.classList.add('was-validated');
    }
  }
}
